import React from 'react';

export default function NotificationOffIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-notification"><g><path className="primary" d="M14.76 19l.23.23A3 3 0 0 1 9 19h5.76zM3.29 4.7a1 1 0 0 1 1.42-1.4l16 16a1 1 0 0 1-1.42 1.4l-16-16z"/><path className="secondary" d="M8.94 4.7c.35-.17.7-.3 1.08-.42L10 4a2 2 0 1 1 3.98.28A7 7 0 0 1 19 11v3.76L8.94 4.7zM5.18 9.42L14.76 19H4a1 1 0 0 1 0-2 1 1 0 0 0 1-1v-5c0-.54.06-1.07.18-1.58z"/></g></svg>
    </Tag>
  )
};
